import { SUBMIT_AUTH_AGENT_BEGIN, SUBMIT_AUTH_AGENT_SUCCESS, SUBMIT_AUTH_AGENT_FAILURE } from "./types";
import { checkNestedObject } from "utils/checkNestedObject";
import API from "../../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";

export const submitAuthAgent = () => async (dispatch, getState) => {
  dispatch({ type: SUBMIT_AUTH_AGENT_BEGIN });

  try {
    if (checkNestedObject(getState(), "form", "authAgentInfo", "values")) {
      const {
        phone_number,
        entity_email_confirm,
        entity_name,
        street_address,
        secondary_address,
        zip_code,
        state,
        city
      } = getState().form.authAgentInfo.values;

      const data = {
        agentRegId: phone_number,
        agentEmailId: entity_email_confirm,
        entityName: entity_name,
        streetAddress: street_address,
        apt: secondary_address,
        zip: zip_code,
        state: state,
        city: city
      };

      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          data[key] = data[key].trim();
        }
      }

      const response = await API({
        method: "POST",
        url: ENDPOINTS.SUBMIT_AUTH_AGENT_INFO,
        data
      });

      if (response && response.status === "OK") {
        dispatch({ type: SUBMIT_AUTH_AGENT_SUCCESS });
      } else {
        dispatch({ type: SUBMIT_AUTH_AGENT_FAILURE });
      }
    }
  } catch (error) {
    dispatch({
      type: SUBMIT_AUTH_AGENT_FAILURE,
      payload: error.response.description
    });
  }
};
